import { Configuration, LogLevel } from "@azure/msal-browser";
import { config } from "../../config";

function getAuthSettings() {

    const clientId = config.clientId
    const resourceId = config.resourceId

    return {
        clientId,
        resourceId
    }
}

const appAuthSettings = getAuthSettings();


const enableLogs = false;

export const msalConfig: Configuration = {
    auth: {
        clientId: appAuthSettings.clientId,
        authority: 'https://login.microsoftonline.com/deloitte.com',

        redirectUri: `${window.location.origin}/`
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }

                if (!enableLogs) {
                    return;
                }

                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        // console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const appScopes = {
    defaultAppApiScope: `${appAuthSettings.resourceId}/user_impersonation`
}

export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "User.Read"
        //"https://orgef191b6b.crm5.dynamics.com/user_impersonation"
    ]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
